import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent, ActivatedRoute, NavigationStart } from '@angular/router';

import { Platform, ModalController  } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { ApiService } from './services/api.service';

import { AnalyticsService } from './services/analytics.service';
import { Title } from '@angular/platform-browser';

import { QuemsomosPage } from './quemsomos/quemsomos.page';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})

export class AppComponent implements OnInit {
  public avatar = "assets/person-circle-sharp.svg";
  public selectedIndex = 0;
  public activePath = '';
  public appPages = [
    {
      title: 'Painel',
      slug: 'dashboard',
      url: '/dashboard',
      icon: 'apps'
    },
    {
      title: 'Treinamentos',
      slug: 'treinamentos',
      url: '/treinamentos',
      icon: 'fitness'
    },
    {
      title: 'Unidades',
      slug: 'unidades',
      url: '/unidades',
      icon: 'business'
    },
    {
      title: 'Eventos',
      slug: 'eventos',
      url: '/eventos',
      icon: 'calendar'
    },
    {
      title: 'Dicas',
      slug: 'dicas',
      url: '/dicas',
      icon: 'flash'
    },
    {
      title: 'Perfil',
      slug: 'perfil',
      url: '/perfil',
      icon: 'bar-chart'
    }
  ];

  user = {
    first_name: '',
    last_name: '',
    email: ''
  }


  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public apiService: ApiService,
    private analyticsService: AnalyticsService,
    private title: Title,
    public modalController: ModalController
  ) {
    this.initializeApp();
    this.router.events.subscribe((event: RouterEvent) => {
      this.activePath = this.router.url;
      this.user = this.apiService.user;
    });
  }
  
  initializeApp() {
    this.analyticsService.startTrackerWithId('UA-146783734-2');
    this.router.events
    .subscribe(event => {
      if (event instanceof NavigationStart) {
        let title = this.title.getTitle();
        if (this.router.getCurrentNavigation().extras.state) {
          title = this.router.getCurrentNavigation().extras.state.title;
        }
        this.analyticsService.trackView(event.url, title);
      }
    });

    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.user = this.apiService.user;
    });
  }

  ngOnInit() {
    this.user.first_name = this.apiService.user.first_name;
    this.user.last_name = this.apiService.user.last_name;
    this.user.email = this.apiService.user.email;
    this.apiService.watchStorage().subscribe((res)=>{
      this.user = JSON.parse(localStorage.getItem('psa_user'));
    })
  }
  
  sair() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  async openWho() {
    const modal = await this.modalController.create({
      component: QuemsomosPage
    });

    modal.onDidDismiss().then(data => {
      
    });

    return await modal.present();
  }
}
